import { ContractType } from "./ContractType.model";
import * as _ from "lodash";
import { ExcellenceCenter } from "./ExcellenceCenter.model";
import { Industry } from "./Industry.model";
import { Responsible } from "./Responsible.model";
export class CompanyContract {
    contractStart: string;
    contractEnd: string;
    contractTypes: ContractType = new ContractType();
    readjustmentDate: string;
    readjustmentNotification: number = 60;
    readjustmentQuoeficient : number = 0;
    contractFinishNotification: Number = 30;
    generated: Boolean = false;
    generatedTemp: boolean = false;
    excellenceCenter: ExcellenceCenter = new ExcellenceCenter();
    industry: Industry = new Industry();
    responsible: Responsible = new Responsible();

    constructor(data?) {
        this.populate(data);
    }

    populate(data) {
        _.forOwn(data, (value, key) => {
            this[key] = value;
        });
    }

    public populateFromServer(r?: any) {
        if (r.contractStart)
            this.contractStart = r.contractStart;
        if (r.contractEnd)
            this.contractEnd = r.contractEnd;
        if (r.readjustmentDate)
            this.readjustmentDate = r.readjustmentDate;
        if (r.readjustmentNotification)
            this.readjustmentNotification = r.readjustmentNotification;
        if (r.readjustmentQuoeficient)
            this.readjustmentQuoeficient = r.readjustmentQuoeficient;
        if (r.contractFinishNotification)
            this.contractFinishNotification = r.contractFinishNotification;
        if(r.contractTypes)
            this.contractTypes.loadOwnerFromServer(r.contractTypes);
        if(r.generated)
            this.generated = r.generated;
        if(r.generatedTemp)
            this.generatedTemp = r.generatedTemp;
        if(r.excellenceCenter)
            this.excellenceCenter = r.excellenceCenter;
        if(r.industry)
            this.industry = r.industry;
        if(r.responsible)
            this.responsible = r.responsible;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/CompanyContract.model.ts